(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('slideshow-thumbnails', class extends baseComponent.default {
      elements = {
          items: '*[data-item]'
      }
      onSliderLoad(slider) {
          this.slider = slider;
          this._setActive(this.slider.swiper.activeIndex);
          this.$items.map((item, i) => {
              item.addEventListener('click', () => {
                  this.slider.slideTo(i);
              });
               item.addEventListener('keydown', (event) => {
                 if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.slider.slideTo(i);
                    }          
              });
          })
          this.slider.swiper.on('slideChange', () => {
              this._setActive(this.slider.swiper.activeIndex);
          })
      }
      _setActive(index) {
          var activeSlide = this.slider.swiper.slides[index];

         this.slider.swiper.slides.forEach(sWslide => {
            if(sWslide.querySelector("modal-trigger")){
                sWslide.querySelector("modal-trigger").setAttribute("aria-hidden",true);
                sWslide.querySelector("modal-trigger").setAttribute("tabindex","-1");
            }
         });

          var previousActiveSlide = this.slider.swiper.slides[this.slider.swiper.previousIndex];
          if(this.active) {
              this.active.classList.remove('!active');
          }
          this.active = this.$items[index];
          this.active.classList.add('!active');
          if(activeSlide){
            if(activeSlide.querySelector("modal-trigger")){
                activeSlide.querySelector("modal-trigger").setAttribute("aria-hidden",false);
                activeSlide.querySelector("modal-trigger").setAttribute("tabindex","0");
            }
          }

          if(this.hasAttribute('horizontal')) {
              this.active.parentNode.scrollLeft = this.active.offsetLeft - 200;
          } else {
              this.active.parentNode.scrollTop = this.active.offsetTop - 200;
          }
      }
  });
})();